module.exports = "<label class=\"checkbox-inline\" *ngFor=\"let role of roles\">\r\n  <input type=\"checkbox\" [id]=\"'roleInput' + role.id\" [formControl]=\"rolesForm.get(role.name)\"\r\n         (change)=\"onSelectedChanged()\"> {{role.label}}\r\n</label>\r\n\r\n<vb-debug-content>\r\n  <p>R: {{rolesForm.value | json}}</p>\r\n</vb-debug-content>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/components/roles-list/roles-list.component.html
// module id = ./src/app/crm/components/roles-list/roles-list.component.html
// module chunks = main